import React, { useState, useEffect } from 'react';
import {
  Button,
  Container,
  Box,
  Modal,
  Tooltip,
  TextField,
  Typography,
  Paper,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

// Static data for other income groups
const staticOtherIncomeGroupData = [
  { incomeGroupId: 1, groupName: 'Investments', remark: 'Income from investments', vat: '5%' },
  { incomeGroupId: 2, groupName: 'Rental Income', remark: 'Income from rental properties', vat: 'Zero-rated' },
  { incomeGroupId: 3, groupName: 'Freelance', remark: 'Income from freelance work', vat: 'Exempted' },
  { incomeGroupId: 4, groupName: 'Dividends', remark: 'Income from dividends', vat: '5%' },
  { incomeGroupId: 5, groupName: 'Royalties', remark: 'Income from royalties', vat: 'Zero-rated' },
  { incomeGroupId: 6, groupName: 'Gifts', remark: 'Income from gifts', vat: 'Exempted' },
];

const EditOtherIncomeGroup = () => {
  const { incomeGroupId } = useParams();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formData, setFormData] = useState({
    groupName: '',
    remark: '',
    vat: '5%',
  });

  const navigate = useNavigate();

  useEffect(() => {
    // Simulate fetching data for the income group to edit
    const incomeGroup = staticOtherIncomeGroupData.find(
      (group) => group.incomeGroupId === parseInt(incomeGroupId)
    );
    if (incomeGroup) {
      setFormData({
        groupName: incomeGroup.groupName,
        remark: incomeGroup.remark,
        vat: incomeGroup.vat,
      });
    }
  }, [incomeGroupId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    // Check if all required fields are filled
    if (!formData.groupName || !formData.remark) {
      alert('Please fill all fields');
      return;
    }
    setShowSuccessModal(true);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '0 auto',
          width: '100%',
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit Other Income Group
        </Typography>
      </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <form onSubmit={handleSave}>
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <TextField
              label="Other Income Group"
              variant="outlined"
              fullWidth
              name="groupName"
              value={formData.groupName}
              onChange={handleChange}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <TextField
              label="Remark"
              variant="outlined"
              fullWidth
              name="remark"
              value={formData.remark}
              onChange={handleChange}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <FormControl component="fieldset">
              <Typography component="legend">VAT</Typography>
              <RadioGroup row aria-label="vat" name="vat" value={formData.vat} onChange={handleChange}>
                <FormControlLabel value="5%" control={<Radio />} label="5%" />
                <FormControlLabel value="zero-rated" control={<Radio />} label="Zero-rated" />
                <FormControlLabel value="exempted" control={<Radio />} label="Exempted" />
              </RadioGroup>
            </FormControl>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Tooltip
              title={
                (!formData.groupName && 'Enter Other Income Group') ||
                (!formData.remark && 'Enter Remark')
              }
              arrow
            >
              <Button
                variant="contained"
                type="submit"
                sx={{ mr: 2, backgroundColor: '#127498ff', '&:hover': { backgroundColor: '#116280ff' } }}
                disabled={!formData.groupName || !formData.remark}
              >
                SAVE
              </Button>
            </Tooltip>
            <Button variant="contained" color="error" onClick={handleCancel}>
              CANCEL
            </Button>
          </Box>
        </form>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Other Income Group Updated ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Other Income Group Updated Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditOtherIncomeGroup;
